<app-navbar [drawer]="drawer"></app-navbar>
<main fxLayout="row" fxLayoutAlign="start stretch">
  <app-nav #drawer></app-nav>
  <div id="main" fxFlex>
    <router-outlet></router-outlet>
  </div>
</main>
<igx-toast #toast message=""></igx-toast>